import { lazyLoadView } from '@router/helpers';
export default [
  {
    path: '/i/:id(\\d+)/iht-balai',
    name: 'iht-balai',
    component: () => lazyLoadView(import('@views/instansi/iht/Balai')),
    meta: {
      title: 'Laporan IHT Balai',
    },
  },
  {
    path: '/i/:id(\\d+)/iht-balai/:dinas_id',
    name: 'iht-balai-detail',
    component: () => lazyLoadView(import('@views/instansi/iht/BalaiDetail')),
    meta: {
      title: 'Lihat Laporan IHT Balai',
    },
  },
];
